import React from 'react'
import moment from 'moment'

import Link from '../Link'

export default ({ data }) => (
  <article key={data._id} className='Home__news-item'>
    <Link to={'/news/' + data._id} className='Link Home__news-link'>
      {data.created && (<span className='Home__news-date Small'>{moment(data.created).from(moment())}</span>)}
      <h1 className='SubHead Home__news-title'>{data.title}</h1>
    </Link>
  </article>
)



// WEBPACK FOOTER //
// ./src/components/News/Preview.jsx